export default __webpack_public_path__ + "static/media/web_screen_chat_en.be12740a.png";